import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiService = {
  getHealth: () => axios.get(`${API}/health`),
  getCategories: () => axios.get(`${API}/categories`),
  getChannels: (category) => axios.get(`${API}/channels${category ? `?category=${category}` : ''}`),
  getChannel: (id) => axios.get(`${API}/channels/${id}`),
  getChannelSchedule: (id, hours = 24) => axios.get(`${API}/channels/${id}/schedule?hours=${hours}`),
  getTVGuide: (hours = 6) => axios.get(`${API}/guide?hours=${hours}`),
  getWhatsOnNow: () => axios.get(`${API}/guide/now`),
  getPPVShows: () => axios.get(`${API}/ppv-shows`),
  search: (query) => axios.get(`${API}/search?q=${query}`),
  getPublicDomain: (genre) => axios.get(`${API}/public-domain${genre ? `?genre=${genre}` : ''}`),
  getPlutoGuide: () => axios.get(`${API}/pluto-guide`),
  getStreams: () => axios.get(`${API}/streams`),
  getPlayerConfig: () => axios.get(`${API}/player/config`),
  getMovies: (genre) => axios.get(`${API}/movies${genre ? `?genre=${genre}` : ''}`),
  getMovie: (id) => axios.get(`${API}/movies/${id}`),
  getTVShows: (genre, status) => axios.get(`${API}/tv-shows${genre ? `?genre=${genre}` : ''}${status ? `&status=${status}` : ''}`),
  getTVShow: (id) => axios.get(`${API}/tv-shows/${id}`),
  getShowEpisodes: (showId, season) => axios.get(`${API}/tv-shows/${showId}/episodes${season ? `?season=${season}` : ''}`),
  getFeaturedContent: () => axios.get(`${API}/content/featured`),
};

export const extractYouTubeVideoId = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/,
    /^([a-zA-Z0-9_-]{11})$/
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
};
